// Projects are created with the lead also added to the `members` array (see
// backend routes/projects.js project-creation handler), so any UI that shows
// the lead's avatar separately from `members` needs to exclude the lead from
// that list to avoid rendering/counting them twice.
import { Project, ProjectMember } from '../types'

const getMemberId = (member: ProjectMember): string =>
  typeof member.user === 'string' ? member.user : member.user._id

export const getNonLeadMembers = (project: Project): ProjectMember[] => {
  const leadId = project.lead._id
  return project.members.filter((member) => getMemberId(member) !== leadId)
}

// Total distinct people on the project: the lead (always counted once) plus
// everyone else in `members`. Works whether or not the lead happens to also
// be present in `members`.
export const getTotalMemberCount = (project: Project): number =>
  getNonLeadMembers(project).length + 1
